import { Component } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ToastrService } from 'ngx-toastr';
import {
  FormControl,
  FormBuilder,
  FormGroup,
  Validators,
  FormArray,
  ValidatorFn,
  AbstractControl,
} from '@angular/forms';
import {
  UserType,
  FileType,
  FileTypeLabel,
  RFQStatusLabel,
} from 'src/app/shared/constants/constants';
import { cloneDeep, first, groupBy } from 'lodash';
import { OmsServiceService } from '../service/oms-service.service';
import { ActivatedRoute } from '@angular/router';
import { CommonService } from 'src/app/services/common-services/common.service';
import { downloadFiles } from 'src/app/shared/utils';
interface InvoiceDetails {
  invoiceNo: string;
  totalAmount: number;
  orderId: number;
  parts: InvoiceItem[];
  attachments: (string | File)[];
  invoiceType: string;
  currency: string;
}
interface InvoiceItem {
  partNo: string;
  quantity: number;
  ratePerUnit: number;
  amount: number;
}
interface DocumentDetails {
  userType: string;
  documentUseFor: string;
  baseUrl: string;
}

@Component({
  selector: 'app-invoice-details',
  templateUrl: './invoice-details.component.html',
  styleUrls: ['./invoice-details.component.scss'],
})
export class InvoiceDetailsComponent {
  invoiceDetails!: FormGroup;
  invoiceForm!: FormGroup;
  resetFileUpload: boolean = false;
  baseUrl = environment.BASE_URL;
  orderId = Number(this.route.snapshot.paramMap.get('id'));
  supplierId = sessionStorage.getItem('supplieruserId') || '';
  invoiceFilesMap: Map<string, any> = new Map();
  fileType = FileType;
  invoiceType: string = FileType.Invoice_GON;
  isGonUpload: boolean = false;
  invoiceData: any = {};
  invoicesData: any[] = [];
  fileTypeGroup: Map<string, any> = new Map();
  FileTypeLabel: any = FileTypeLabel;
  isRevised: boolean = false;
  RFQStatusLabel: any = RFQStatusLabel;
  allCurrency: any[] = [];
  invoiceCurrency: string = 'INR';
  constructor(
    private toastr: ToastrService,
    private route: ActivatedRoute,
    private commonService: CommonService,
    private omsService: OmsServiceService,
  ) {
  }
  ngOnInit() {
    this.getInvoiceDetails();
  }

  getInvoiceStatus = (status: any) => status;
  getInvoiceDetails() {
    const url = `${this.baseUrl}v2/oms/customer-invoice?custOrderId=${this.orderId}`

    this.commonService.getData(url).subscribe((res : any) => {
      this.invoicesData = res.response;
    })
   
  }

  getTotalAmount() {
    const totalAmount = this.invoiceForm.value.subInvoices.reduce(
      (accumulator: any, currentValue: any) => accumulator + currentValue.amount,
      0,
    );
    this.invoiceDetails.controls['totalAmount'].patchValue(totalAmount);
  }

  /**Invoice Files and download**/
  getFileTypeLabel(fileType: any): string {
    return this.FileTypeLabel[fileType];
  }
  groupAttachmentsByFileType(filesData: any): any {
    const result: any = groupBy(filesData, 'fileType');
    this.fileTypeGroup = result;
  }
  getFileTypes() {
    return Object.entries(this.fileTypeGroup).map(([key, value]) => ({ key, value }));
  }
  downloadInvoice(id: number, fileName: string) {
    downloadFiles(this.baseUrl, this.commonService, this.toastr, id, fileName);
  }
  /**Invoice Files and download**/
  backDetails() {
    this.isRevised = false;
  }
}
